import { skipToken, useQuery } from '@tanstack/react-query';

import { Permissions } from '@air/api';
import { type Workspace } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

export const CONTAINER_PERMISSIONS_KEY = '@plugin-ui/CONTAINER_PERMISSIONS';

// biome-ignore lint/style/noMagicNumbers: Time calculation - 1 hour in milliseconds
const ONE_HOUR_MS = 60 * 60 * 1000;

export type UseContainerPermissionsParams = {
  /** When set, returns board-scoped permissions; otherwise workspace-scoped. */
  boardId: string | undefined;
  workspaceId: Workspace['id'] | undefined;
};

export const getContainerPermissionsKey = (params: UseContainerPermissionsParams) => {
  return [CONTAINER_PERMISSIONS_KEY, params];
};

/**
 * Fetches permissions for the current container (board if present, else workspace).
 * Matches the web app's parent-context model used by `canDeleteAsset`.
 */
export const useContainerPermissions = ({ boardId, workspaceId }: UseContainerPermissionsParams) => {
  return useQuery({
    queryFn: workspaceId
      ? () =>
          callAirApi(() =>
            Permissions.getFromObjects({
              objects: boardId ? { boardIds: [boardId] } : { workspaceId },
              workspaceId,
            }),
          )
      : skipToken,
    queryKey: getContainerPermissionsKey({ boardId, workspaceId }),
    staleTime: ONE_HOUR_MS,
  });
};
